/**
 * Copyright (c) 2010-2021 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { FetchProxyResponse } from './fetch-proxy-response';

@Injectable({ providedIn: 'root' })
export abstract class FetchProxy {
    abstract send(
        input: RequestInfo,
        init?: RequestInit,
        responseType?: 'json' | 'text' | 'blob' | 'arraybuffer'
    ): Observable<FetchProxyResponse>;
}
